import { render, staticRenderFns } from "./NavigationDropdownItem.vue?vue&type=template&id=12095254&scoped=true&"
import script from "./NavigationDropdownItem.vue?vue&type=script&lang=js&"
export * from "./NavigationDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12095254",
  null
  
)

export default component.exports